<template>
  <hm-content title>
    <div class="table-panel flex flex-end mb20">
      <div>
        <el-select
          size="small"
          clearable
          placeholder="选择显示内部人员"
          v-model="searchCondition.showAgentUserName"
          class="mr10"
          filterable
          style="width: 180px"
        >
          <el-option
            v-for="(item, i) in showAgentUserNameList"
            :key="i"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-select
          size="small"
          clearable
          placeholder="签约公司"
          v-model="searchCondition.contractCompanyId"
          class="mr10"
          filterable
        >
          <el-option
            v-for="(item, i) in companyList"
            :key="i"
            :label="item.companyName"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-select
          size="small"
          clearable
          placeholder="签约状态"
          v-model="searchCondition.registerState"
          class="mr10"
          filterable
        >
          <el-option
            v-for="(item, i) in registerStateList"
            :key="i"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-input
          clearable
          v-model="searchCondition.fuzzyCustomerKeyWords"
          placeholder="请输入姓名/手机号/身份证/图片查询"
          size="small"
          class="ipt mr10"
          style="width: 300px"
        ></el-input>
      </div>
      <div>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>
    <el-table
      :data="list"
      style="width: 100%"
      ref="table"
      stripe
      border
      size="small"
    >
      <el-table-column
        header-align="center"
        align="center"
        type="index"
        label="序号"
        width="50"
        :index="(index) => index + (currentPage - 1) * pageSize + 1"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="签约公司"
        prop="companyName"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="对方姓名"
        prop="idcardName"
      >
      <template slot-scope="scope">
        <div>{{scope.row.idcardName}}<span v-if="scope.row.agentUserName">({{scope.row.agentUserName}})</span></div>
      </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="对方号码"
        prop="authMobile"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="身份证号码"
        prop="idcardNo"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="身份证人脸图"
        width="250"
        prop="idcardFrontImg"
      >
        <template slot-scope="scope">
          <a :href="scope.row.idcardFrontImg" target="_blank"
            ><div>{{ scope.row.idcardFrontImg }}</div></a
          >
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="身份证国徽图"
        width="250"
        prop="idcardBackImg"
      >
        <template slot-scope="scope">
          <a :href="scope.row.idcardBackImg" target="_blank"
            ><div>{{ scope.row.idcardBackImg }}</div></a
          >
        </template>
      </el-table-column>
      <!-- <el-table-column
        header-align="center"
        align="center"
        label="合同编号"
        prop="transactionId"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="下载路径"
        prop="downloadUrl"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="查看路径"
        prop="viewUrl"
      ></el-table-column> -->
      <el-table-column
        header-align="center"
        align="center"
        label="签约状态"
        prop="registerState"
      >
        <template slot-scope="scope">
          <div v-for="(item, i) in registerStateList" :key="i">
            <div v-if="scope.row.registerState === item.value">
              <span class="red" v-if="scope.row.registerState === 'noRel'" @click="showForm2(scope.row)">{{item.label}}</span>
              <span v-else>{{item.label}}</span>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="签约时间"
        prop="createTime"
      ></el-table-column>
      <el-table-column
        prop="操作"
        header-align="center"
        align="center"
        label="操作"
      >
        <template slot-scope="scope">
          <div class="flex flex-center">
            <div
              v-if="
                scope.row.idcardLetAuditState !== 'yes' &&
                scope.row.idcardImgAuditState !== 'yes'
              "
            >
              <el-button
                size="small"
                type="text"
                @click="showForm(scope.row, scope.$index)"
                >身份证图片验证</el-button
              >
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="total"
        @size-change="handleSizeChange"
        @current-change="paging"
        layout="total,sizes,  prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
    >
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="200px"
        :rules="rules"
      >
        <el-form-item label="头像面:" prop="idcardFrontImg">
          <el-upload
            class="upload flex"
            ref="eluploadMainPic"
            :limit="1"
            drag
            :data="{ fileDir: 'mall' }"
            :headers="{ 'X-Access-Token': $token }"
            :action="$uploadUrl"
            :onSuccess="uploadMainPicSucc"
            :beforeUpload="beforeUpload"
            :onProgress="uploading"
            :show-file-list="uploadShow"
            v-if="!ruleForm.idcardFrontImg"
          >
            <el-image
              class="idCardImg"
              src="https://imgcdn.hemiao100.com/commission/ps91fadb10ea2fc8bd-9918-4666-893d-f93b6a54d03c.png"
            ></el-image>
          </el-upload>
          <div class="priview" v-if="ruleForm.idcardFrontImg">
            <img :src="ruleForm.idcardFrontImg" alt="头像面" />
            <div class="opreat-wrapper flex item-center flex-center">
              <el-button type="text" @click="handleRemove">删除</el-button>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="国徽面:" prop="idcardBackImg">
          <el-upload
            class="upload flex"
            ref="eluploadMainPic"
            :limit="1"
            drag
            :data="{ fileDir: 'mall' }"
            :headers="{ 'X-Access-Token': $token }"
            :action="$uploadUrl"
            :onSuccess="uploadMainPicSucc2"
            :beforeUpload="beforeUpload"
            :onProgress="uploading"
            :show-file-list="uploadShow2"
            v-if="!ruleForm.idcardBackImg"
          >
            <el-image
              class="idCardImg"
              src="https://imgcdn.hemiao100.com/commission/psd725365c079fc699-36c2-4934-bdcd-0385690d7504.png"
            ></el-image>
          </el-upload>
          <div class="priview" v-if="ruleForm.idcardBackImg">
            <img :src="ruleForm.idcardBackImg" alt="国徽面" />
            <div class="opreat-wrapper flex item-center flex-center">
              <el-button type="text" @click="handleRemove2">删除</el-button>
            </div>
          </div>
        </el-form-item>
        <div class="flex flex-center">
          <el-button type="primary" size="small" @click="submitForm('ruleForm')"
            >提交</el-button
          >
          <el-button size="small" @click="cancel">取消</el-button>
        </div>
      </el-form>
    </el-dialog>

    <el-dialog
      :title="title2"
      :close-on-click-modal="false"
      :visible.sync="docheckDialogVisible"
    >
      <el-form
        :model="ruleForm2"
        ref="ruleForm2"
        label-width="200px"
        :rules="rules2"
      >
        <el-form-item label="签约公司:" prop="companyName">
          {{ruleForm2.companyName}}
        </el-form-item>

        <el-form-item label="签约人:" prop="idcardName">
          {{ruleForm2.idcardName}}
        </el-form-item>

        <el-form-item label="签约人手机号:" prop="authMobile">
          {{ruleForm2.authMobile}}
        </el-form-item>

        <el-form-item label="银行卡列表:" prop="bankRelId">
          <el-select
            size="small"
            clearable
            placeholder="银行卡列表"
            v-model="ruleForm2.bankRelId"
            class="mr10"
            filterable
          >
            <el-option
              v-for="(item, i) in ruleForm2.bankRelList"
              :key="i"
              :label="item.bankName + '(' +item.bankCardNumber + ')'"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <div class="flex flex-center">
          <el-button type="primary" size="small" @click="submitForm2('ruleForm2')"
            >提交</el-button
          >
          <el-button size="small" @click="cancel2">取消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </hm-content>
</template>

<script>
import area from "@/utils/area";
export default {
  components: {},
  data() {
    return {
      id: "",
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      dialogVisible: false,
      title: "身份证图片验证",
      ruleForm: {
        idcardFrontImg: "",
        idcardBackImg: "",
      },
      bankCardList: [
        {
          label: "微信",
          value: "weChat",
        },
        {
          label: "支付宝",
          value: "aliPay",
        },
        {
          label: "银行卡",
          value: "aliPayNew",
        },
      ],
      rules: {
        idcardFrontImg: [
          { required: true, message: "请上传头像面", trigger: "change" },
        ],
        idcardBackImg: [
          { required: true, message: "请上传国徽面", trigger: "change" },
        ],
      },
      searchCondition: {
        contractCompanyId: "",
        fuzzyCustomerKeyWords: "",
        registerState: "pass",
        showAgentUserName: "no",
      },
      registerStateList: [
        {
          value: "pass",
          label: "通过注册",
        },
        {
          value: "noRel",
          label: "无关联",
        },
      ],
      companyList: [],
      uploadShow: true,
      uploadShow2: true,
      currentRow: {},
      docheckDialogVisible: false,
      title2: "手动签约",
      ruleForm2: {},
      rules2:{
        bankRelId: [
          { required: true, message: "请选择银行卡", trigger: "change" },
        ],
      },
      showAgentUserNameList:[
        {
          label: "显示公司内部人员",
          value: "yes",
        },
        {
          label: "不显示公司内部人员",
          value: "no",
        },
      ],
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.id = this.$route.query.id;
    this.searchCondition.contractCompanyId = this.id;
    this.queryList();
    this.ThirdCompanyInfoQueryPageList();
  },
  methods: {
    async queryList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
      };
      let conditions = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, conditions);
      const { result } = await this.$store.dispatch(
        "thirdContractCustomerInfoQueryPageList",
        params
      );
      const { records, total } = result;
      this.list = records;
      this.total = total;
    },
    search() {
      // if(!this.searchCondition.contractCompanyId){
      //   this.$message({
      //     message: "请选择签约公司",
      //     type: "warning"
      //   });
      //   return;
      // }
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    async ThirdCompanyInfoQueryPageList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
      };
      const { result } = await this.$store.dispatch(
        "ThirdCompanyInfoQueryPageList",
        params
      );
      const { records, total } = result;
      this.companyList = records;
    },
    beforeUpload(file) {
      const extension =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
          "jpg" ||
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "gif";
      const extension2 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
        "jpeg";
      const extension3 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
      const extension4 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
      // file.size单位为b，除以1024得到kb
      const limitSize = file.size / 1024 <= 1020;
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: "上传模板只能是 jpg、jpeg、png、bmp格式!",
          type: "warning",
        });
      }
      if (!limitSize) {
        this.$message({
          message: "上传模板大小不能超过 1M!",
          type: "warning",
        });
      }
      return (extension || extension2 || extension3 || extension4) && limitSize;
    },
    uploadMainPicSucc(jsonData) {
      if (jsonData.code === 0) {
        this.ruleForm.idcardFrontImg = jsonData.result;
        this.uploadShow = false;
      }
    },
    uploadMainPicSucc2(jsonData) {
      if (jsonData.code === 0) {
        this.ruleForm.idcardBackImg = jsonData.result;
        this.uploadShow2 = false;
      }
    },
    // 正在上传
    uploading() {
      this.isSaving = true;
      this.uploadShow = true;
      this.uploadShow2 = true;
    },
    // 移除上传文件
    handleRemove() {
      this.ruleForm.idcardFrontImg = "";
    },
    handleRemove2() {
      this.ruleForm.idcardBackImg = "";
    },
    showForm(row) {
      this.ruleForm.idcardFrontImg = "";
      this.ruleForm.idcardBackImg = "";
      this.currentRow = row;
      this.dialogVisible = true;
      this.title =
        "身份证图片验证(" + row.idcardName + "+" + row.authMobile + ")";
    },
    async submitForm(formName) {
      const isValid = await this.$refs[formName].validate();
      if (isValid) {
        this.addNewIdcardImgByCustomerId(this.currentRow);
      }
    },
    async addNewIdcardImgByCustomerId(row) {
      let params = {
        customerId: row.hemiaoCustomerId,
        idcardBackImg: this.ruleForm.idcardBackImg,
        idcardFrontImg: this.ruleForm.idcardFrontImg,
      };
      const { code, result } = await this.$store.dispatch(
        "addNewIdcardImgByCustomerId",
        params
      );
      if (code === "0") {
        if (result.code === "succ") {
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.queryList();
        } else {
          this.$alert(result.content, result.title, {
            confirmButtonText: "确定",
          });
        }
        this.dialogVisible = false;
      }
    },
    cancel() {
      this.ruleForm.idcardFrontImg = "";
      this.ruleForm.idcardBackImg = "";
      this.currentRow = {};
      this.dialogVisible = false;
    },
    showForm2(row){      
      this.ruleForm2 = row;
      console.log("this.ruleForm2:",this.ruleForm2);
      this.docheckDialogVisible = true;
    },
    async submitForm2(formName) {
      const isValid = await this.$refs[formName].validate();
      if (isValid) {
        this.doCheckCustomerIdentityElements();
      }
    },
    async doCheckCustomerIdentityElements(){
      let params = {
        customerId: this.ruleForm2.hemiaoCustomerId,
        bankRelId: this.ruleForm2.bankRelId,
        bankSaveMobile: this.ruleForm2.authMobile,
        contractCompanyId: this.ruleForm2.contractCompanyId,
      };
      console.log("params:",params);
      // return;
      const { code, result } = await this.$store.dispatch(
        "doCheckCustomerIdentityElements",
        params
      );
      if (code === "0") {
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.queryList();
        this.docheckDialogVisible = false;
      }  
    },
    cancel2(){
      this.docheckDialogVisible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.red {
  color: #e50065;
}
.upload {
  width: 400px;
  /deep/ .el-icon-plus {
    margin-top: 40px;
  }
  /deep/ .el-upload-dragger {
    width: 347px;
    height: 259px;
  }
  /deep/ .el-upload__tip {
    width: 300px;
    line-height: 30px;
  }
}
.priview {
  position: relative;
  width: 347px;
  height: 259px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .video {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.idCardImg {
  width: 100%;
  height: 100%;
}
.red{
  color: #fb282a;
}
</style>
